import React from 'react'
import { Link } from 'react-router-dom'

export const AiTrial: React.FC = () => {
    return (
        <>
            <h1 className="font-bold text-2xl mt-10 text-center">
                Пользуйся справочником бесплатно
            </h1>
            <div className="mt-6 flex flex-col md:flex-row gap-4">
                <div className="text-xl font-bold content-center">
                    Справочник
                    <br />с нужными подсказками
                </div>
                <div className="card_item card_item_light">
                    <h2 className="!text-sm">Кому полезен справочник</h2>
                    <p>Специалистам по закупкам</p>
                    <p>Инициаторам закупок</p>
                    <p>
                        Контрактным управляющим Юристам, экономистам Органам
                        контроля
                    </p>
                    <p>Руководителям</p>
                    <p>Предпринимателям</p>
                    <p>Участникам закупок</p>
                </div>
                <div className="flex flex-col card_item card_item_dark !bg-[#1051F5]">
                    <h2 className="!text-sm flex-grow">
                        Бесплатный справочник с нейросетевыми технологиями
                    </h2>
                    <div className="mt-4 md:mt-0">
                        <Link
                            to={'/'}
                            className="rounded-full px-6 py-2 text-[#407bff] bg-white"
                        >
                            Попробовать справочник
                        </Link>
                    </div>
                </div>
            </div>
        </>
    )
}
